import React from 'react';

import BootstrapBadge from 'react-bootstrap/Badge';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { Icon } from '../Icon';
import { AllowedIconNameT } from '../Icon/allowedIcons';

import '@consumer-bootstrap/components/badges.scss';

export type BadgeVariantT =
| 'danger'
| 'info'
| 'pending'
| 'success'
| 'warning'
;
export type BadgeVariantIconNameMapT = { [key in BadgeVariantT]: AllowedIconNameT; };
export const BADGE_VARIANT_ICON_NAME_MAP: BadgeVariantIconNameMapT = {
  danger: 'exclamation-circle',
  info: 'info-circle',
  pending: 'clock',
  success: 'check-circle',
  warning: 'exclamation-triangle',
};

export type BadgePropsT = {
  text: string;
  variant: BadgeVariantT;
  className?: string;
  hasIcon?: boolean;
};

export type BadgeT = React.FC<BadgePropsT>;

export const Badge: BadgeT = ({
  className,
  hasIcon,
  text,
  variant,
}) => {
  const classNames = mergeClassNameStrings(className, `badge-${variant}`);

  return (
    <BootstrapBadge pill bg="" className={classNames}>
      {hasIcon && <Icon
        className="badge-icon"
        iconName={BADGE_VARIANT_ICON_NAME_MAP[variant]}
      />}
      <span>{text}</span>
    </BootstrapBadge>
  );
};
